import request from "@/utils/request";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from '@/CommonDP/utils/globalParams.js';
// 进度管理
export default {
  queryPlanList(data) {
    return request.post(`/prj-plan-task/query-tree`, data).then((res) => res);
  },

  queryTreeTask(data) {
    return request.post(`/prj-plan-task/list`, data).then((res) => res);
  },

  addPlan(data) {
    return request.post(`/prj-plan-task/add`, data).then((res) => res);
  },

  delPlan(taskId) {
    return request
      .post(`/prj-plan-task/delete?taskId=${taskId}`)
      .then((res) => res);
  },

  editPlan(data) {
    return request.post(`/prj-plan-task/update`, data).then((res) => res);
  },

  movePlan(taskId, moveType) {
    return request
      .post(`/prj-plan-task/move?taskId=${taskId}&moveType=${moveType}`)
      .then((res) => res);
  },

  queryDetail(taskId) {
    return request
      .get(`/prj-plan-task/query?taskId=${taskId}`)
      .then((res) => res);
  },

  upAndDownPlan(taskId, moveType) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/prj-plan-task/upAndDown");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}?taskId=${taskId}&moveType=${moveType}`);
    }
    return request
      .post(`/prj-plan-task/upAndDown?taskId=${taskId}&moveType=${moveType}`)
      .then((res) => res);
  },

  queryTaskTypeTree() {
    return request.get(`/task-package/dic/task/tree`).then((res) => res);
  },

  queryDic() {
    return request.get(`/prj-coordination/dic-init`).then((res) => res);
  },

  addTaskLabel(data) {
    return request.post(`/task-package/save-label`, data).then((res) => res);
  },

  addComment(data) {
    return request.post(`/prj-plan-task/add-discuss`, data).then((res) => res);
  },

  addProgressFeedBack(data) {
    return request.post(`lc/prj-plan-task/add-progress`, data).then((res) => res);
  },

  exportDesignChange(flowBusinessId) {
    return request.get(`/lc/flow/export?flowBusinessId=${flowBusinessId}`, {
      responseType: 'blob'
    })
  },

  addLinkTask(data) {
    return request.post(`/prj-plan-task/link-task`, data).then((res) => res);
  },

  addLinkTaskDrag(data) {
    return request
      .post(`/prj-plan-task/link-task-manual`, data)
      .then((res) => res);
  },

  delLinkTaskDbClick(data) {
    return request
      .post(`/prj-plan-task/move/link-task-manual`, data)
      .then((res) => res);
  },

  queryComment(taskId) {
    return request
      .get(`/prj-plan-task/query-discuss?taskId=${taskId}`)
      .then((res) => res);
  },
  queryPrjAllPage(data, pageNum, pageSize) {
    return request
      .post(`/flow/workbench/queryPrjAllPage?pageNum=${pageNum}&pageSize=${pageSize}`, data)
      .then((res) => res);
  },

  queryUpdateLog(taskId) {
    return request
      .get(`/prj-plan-task/query-his?taskId=${taskId}`)
      .then((res) => res);
  },

  queryProgressFeedBack(taskId) {
    return request
      .get(`/prj-plan-task/query-progress?taskId=${taskId}`)
      .then((res) => res);
  },

  queryTaskLabelList() {
    return request.get(`/system-settings/enable-label`).then((res) => res);
  },

  queryChildItemList(prjId) {
    return request.get(`/prjstage/prj/${prjId}`).then((res) => res);
  },

  queryChildItemGroupList(prjId) {
    return request.get(`/prjstage/group/list/${prjId}`).then((res) => res);
  },

  changeGrouState(data) {
    return request
      .get(`/prjstage/group/forbidden/${data.ID}/${data.State}`)
      .then((res) => res);
  },

  queryChildItemGroupById(groupId) {
    // todo
    return request.get(`/prjstage/group/details/${groupId}`).then((res) => res);
  },

  saveChildItemGroup(type, data) {
    return request
      .post(`/prjstage/group/${type}`, data)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  },

  urgePlan(data) {
    return request.post(`/incomleteJob/add`, data).then((res) => res);
  },

  querySpecList(params) {
    return request
      .get(`/oper-personnel/spec-stage-list`, { params })
      .then((res) => res);
  },

  queryAverageTaskTime(params) {
    // todo
    return request
      .get(`/prj-plan-task/average-task-time`, { params })
      .then((res) => res);
  },
  // 旧 专业和责任岗位
  querySpecRoleList() {
    return request.get(`/task-package/dic-init`).then((res) => res);
  },
  filterUserList(params) {
    return request
      .get(`/prj-plan-task/filter-spec-child`, { params })
      .then((res) => res);
  },
  // 新 专业和责任岗位
  taskpackageinitSpecRoleDic(prjId, enterpriseId) {
    return request
      .get(
        `/task-package/initSpecRoleDic?prjId=${prjId}&enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  taskpackagespecList(prjId, enterpriseId) {
    return request
      .get(`/task-package/specList?prjId=${prjId}&enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  taskpackageroleListSpecChange(specList) {
    return request
      .post(`/task-package/roleListSpecChange`, specList)
      .then((res) => res);
  },
  queryPlanFlowDefinitionList(enterpriseId) {
    return request.get(
      `/flow/queryPlanFlowDefinitionList?enterpriseId=${enterpriseId}`
    );
  },
  queryTaskPackageChildList(prjId) {
    return request.get(`/task-package/childList?prjId=${prjId}`);
  },
  queryTaskPre(taskId) {
    return request.get(`/prj-plan-task/query-task-pre?taskId=${taskId}`);
  },
  queryFlowButton(flowInstanceId) {
    return request.get(`/flow/queryFlowButton?flowInstanceId=${flowInstanceId}`);
  },

  // 更新计划是否启动状态
  updateSuspend (params) {
    return request.post(`/prj-plan-task/updateSuspend`, params);
  }
};
